import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition && to.meta.keepAlive) {
    return savedPosition;
  }
  if (to.hash) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ selector: to.hash });
      }, 600);
    });
  }
};

export default new Router({
  mode: "history", // 后端支持可开
  scrollBehavior: scrollBehavior,
  routes: [
    {
      path: "/oms/",
      redirect: "/oms/dashboard",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/oms/dashboard",
          name: "vuetify-dashboard",
          component: () => import("@/view/pages/vuetify/Vuetify.vue"),
          children: [
            {
              path: "",
              name: "dashboard",
              component: () => import("@/view/pages/Dashboard.vue"),
            },
          ],
        },
        {
          path: "/oms/builder",
          name: "builder",
          component: () => import("@/view/pages/Builder.vue"),
        },
        {
          path: "/oms/expend",
          name: "expend",
          component: () => import("@/view/pages/expend/index.vue"),
        },

        {
          path: "/oms/invoice",
          name: "vuetify-invoice",
          component: () => import("@/view/pages/vuetify/Vuetify.vue"),
          children: [
            {
              path: "request",
              name: "invoice",
              component: () =>
                import("@/view/pages/invoice/InvoiceRequest.vue"),
            },
            {
              path: "open",
              name: "open-invoice",
              component: () => import("@/view/pages/invoice/OpenInvoice.vue"),
            },
            {
              path: "title",
              name: "invoice-title",
              component: () => import("@/view/pages/invoice/InvTitle.vue"),
            },
          ],
        },
        // {
        //   path: "/oms/invoice",
        //   name: "invoice",
        //   component: () => import("@/view/pages/invoice/Invoice.vue")
        // },
        // {
        //   path: "/oms/open-invoice",
        //   name: "open-invoice",
        //   component: () => import("@/view/pages/invoice/OpenInvoice.vue")
        // },
        {
          path: "/oms/secret",
          name: "secret-vuetify",
          component: () => import("@/view/pages/vuetify/Vuetify.vue"),
          children: [
            {
              path: "order",
              name: "secret-order",
              component: () => import("@/view/pages/secret/Order.vue"),
            },
          ],
        },
        {
          path: "/oms/tunnel",
          name: "tunnel-vuetify",
          component: () => import("@/view/pages/vuetify/Vuetify.vue"),
          children: [
            {
              path: "order",
              name: "tunnel-order",
              component: () => import("@/view/pages/tunnel/Order.vue"),
            },
          ],
        },
        {
          path: "/oms/white",
          name: "whitelist-vuetify",
          component: () => import("@/view/pages/vuetify/Vuetify.vue"),
          children: [
            {
              path: "list",
              name: "ip-whitelist",
              component: () => import("@/view/pages/whitelist/index.vue"),
            },
          ],
        },
        {
          path: "/oms/generate",
          name: "secret-vuetify",
          component: () => import("@/view/pages/vuetify/Vuetify.vue"),
          children: [
            {
              path: "api",
              name: "generate-api",
              component: () => import("@/view/pages/generate-api/index.vue"),
            },
          ],
        },
      ],
    },
    {
      path: "/",
      component: () => import("@/view/pages/auth/login_pages/Login-1"),
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/auth/login_pages/Login-1"),
        },
        {
          name: "register",
          path: "/register",
          component: () => import("@/view/pages/auth/login_pages/Login-1"),
        },
      ],
    },
    {
      path: "*",
      redirect: "/404",
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/404.vue"),
    },
  ],
});
